import { ComponentType, type ComponentProps } from 'react';

import * as AllIcons from './index.js';
import { makeNormal } from './utils/nameTransform.js';

type WrapKey<
  TKey,
  TPrefix extends string,
  TSuffix extends string = '',
> = TKey extends string ? `${TPrefix}${TKey}${TSuffix}` : never;

export type IconsList = keyof typeof AllIcons;

const svgIconModules = import.meta.glob('./raw-icons/*.svg', {
  query: '?react',
}) as Record<
  WrapKey<'*', './raw-icons/', '.svg'>,
  () => Promise<{
    default: ComponentType<ComponentProps<'svg'>>;
  }>
>;

function removePathPrefix<Value>(
  obj: Record<WrapKey<'*', './raw-icons/', '.svg'>, Value>,
) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      makeNormal(key.replace('./raw-icons/', '')),
      value,
    ]),
  ) as Record<WrapKey<'*', '', '.svg'>, Value>;
}

export const Icons = removePathPrefix(svgIconModules);
